import { BaseApi } from '@/core/api/base.api'
import { Room } from "@/core/api/room.api";
import { roomURLShareService} from "@/core/service/room.urlShare.service";
import { RoomInfo } from '@/core/api/room.info.api'

class RoomURLShareApi extends BaseApi {
  constructor() {
    super()
    Room.URLShare = this

    Room.ready(async e => {
      if(!RoomInfo.useModule('docShare')){
        return;
      }

      this._eventListen(this.#Events);

      await (async () => {
        const { data } = await roomURLShareService.getURLShareList();
        Room.emit('room_urlshare_init', data.data)
      })()

    });
  }

  #Events = {
    room_urlshare_create: function (e) {
      Room.emit(e);
    },
    room_urlshare_start: function (e) {
      Room.emit(e);
    },
    room_urlshare_remove: function (e) {
      Room.emit(e);
    },
    room_urlShare_update: function (e) {
      Room.emit(e);
    }
  }

  async createURLShare(params) {
    return (await roomURLShareService.createURLShare(params)).data;
  }

  async removeURLShare(params) {
    return (await roomURLShareService.removeURLShare(params)).data;
  }

  async updateURLShare(params) {
    return (await roomURLShareService.updateURLShare(params)).data;
  }

  async getURLShareList() {
    return (await roomURLShareService.getURLShareList()).data;
  }

  async startURLShareList(params) {
    return (await roomURLShareService.startURLShareList(params)).data;
  }
}

export const URLShare = new RoomURLShareApi();
